import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
    CardTitle,
    Table,
} from 'reactstrap';

import { RisksRates } from 'src/modules/3rd-party-management/constants';

import useTopDeforestationHotspotRegions from './hooks/useTopDeforestationHotspotRegions';

const TopDeforestationHotspotRegionsSkeleton = () => (
    <Card className="h-100 mb-0">
        <CardBody>
            <div className="dt-field dt-skeleton mb-4" style={{ width: '50%', height: '24px' }} />
            <div className="dt-field dt-skeleton" style={{ width: '100%', height: '220px' }} />
        </CardBody>
    </Card>
);

const RiskLevelBadge = ({
    t,
    riskLevel,
}) => {
    const config = RisksRates[riskLevel];

    if (!config) {
        return <span>—</span>;
    }

    return (
        <span
            className="badge text-white"
            style={{ backgroundColor: config.color }}
        >
            {t(config.title)}
        </span>
    );
};

const TopDeforestationHotspotRegions = ({
    t,
}) => {
    const {
        data: regions,
        isLoading,
        isFetching,
        isError,
    } = useTopDeforestationHotspotRegions({ t });

    if (isLoading || isFetching) {
        return <TopDeforestationHotspotRegionsSkeleton />;
    }

    if (isError || !regions) {
        return null;
    }

    return (
        <Card className="h-100 mb-0">
            <CardBody>
                <CardTitle tag="h6" className="mb-4 overview-section-title ">
                    {t('Top Deforestation Hotspot Regions')}
                </CardTitle>

                <div className="table-responsive">
                    {!regions.length ? (
                        <div className="text-center py-4 text-muted">
                            {t('No deforestation hotspot regions available.')}
                        </div>
                    ) : (
                        <Table className="mb-0" responsive borderless>
                            <thead>
                                <tr>
                                    <th>{t('Region')}</th>
                                    <th>{t('Risk Level')}</th>
                                    <th>{t('Land Evaluated')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {regions.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.region || '—'}</td>
                                        <td>
                                            <RiskLevelBadge
                                                t={t}
                                                riskLevel={item.riskLevel}
                                            />
                                        </td>
                                        <td>{item.landEvaluated || '—'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(TopDeforestationHotspotRegions);
